<template>
  <div>
    <v-row class="pl-6 ma-0 bt-line condition-wrap">
      <!-- 시간 -->
      <v-col
        cols="12"
        class="pa-0 pb-1 mt-3 d-flex justify-space-between"
        @click="toSelectDate"
      >
        <span class="label">출퇴근 변경 신청일</span>
        <span class="date">{{ GET_WORK_YMD }}</span>
      </v-col>
      <v-col
        cols="12"
        class="pa-0 pt-5 pb-1 bt-line mt-3 d-flex justify-space-between"
      >
        <span class="label">변경 후 출근시간</span>
        <span class="date">{{ GET_REQ_S_HM }}</span>
      </v-col>
      <v-col cols="12" class="pa-0 pt-4 bt-line mt-3 borderLine-outer">
        <div class="d-flex justify-space-between">
          <span class="borderLine-title">변경 후 퇴근시간</span>
          <span class="date">{{ GET_REQ_E_HM }}</span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import applCdMixin from '@/mixins/applCdMixin.js';
import extraOptionsMixin from '@/mixins/extraOptionsMixin.js';

import { mapGetters } from 'vuex';

export default {
  mixins: [applCdMixin, extraOptionsMixin],
  computed: {
    ...mapGetters('ELA', ['GET_WORK_YMD', 'GET_REQ_S_HM', 'GET_REQ_E_HM']),
  },
  methods: {},
};
</script>

<style></style>
